import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/nodata.png'


const _withScopeId = n => (_pushScopeId("data-v-58fdfc5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "img-nav" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "cover-div" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "no-data",
  src: _imports_0,
  alt: ""
}
const _hoisted_6 = { class: "text" }

import { useProIndexStore } from "@/store/index";
import { watch, ref, onMounted, nextTick } from "vue";
import { getProductData, getSubMenuCont } from "@/api/product";

export default /*#__PURE__*/_defineComponent({
  __name: 'Content',
  props: {
  menu_index: {
    type: String,
    // required: true
  },
  sub_menu_index: {
    type: Number,
    // required: true
  },
},
  emits: ["openSubMenu"],
  setup(__props, { emit: emits }) {

const props = __props;




const baseUrl = ref(process.env.VUE_APP_BASE_URL);
const content = ref("");
const titleList = ref([]);
const current_index = ref("");
const is_children = ref(false);
const getTitleList = async (proid, index) => {
  await getSubMenuCont(proid, index).then((res) => {
    // console.log(res);
    // is_children.value = true
    titleList.value = res.data.content;
  });
};
watch(
  () => props.menu_index,
  () => {
    useProIndexStore().allIndex = String(props.menu_index);
  },
  {
    immediate: true,
    deep: true,
  }
);

watch(
  () => props.sub_menu_index,
  () => {
    // console.log(props.sub_menu_index);
    getTitleList(props.sub_menu_index, props.menu_index);
    // getSubMenuCont(props.sub_menu_index,props.menu_index).then(res => {
    //     console.log(res);
    //     // is_children.value = true
    //     titleList.value = res.data.content;
    // });
  },
  {
    immediate: true,
    deep: true,
  }
);

watch(
  () => useProIndexStore().proIndex,
  () => {
    getTitleList(useProIndexStore().proIndex, useProIndexStore().allIndex);

  },
  {
    immediate: true,
    deep: true,
  }
);
onMounted(() => {
  console.log("mounted");
  getSubMenuCont(useProIndexStore().proIndex, props.menu_index).then((res) => {
    // console.log(11100, res);
    // is_children.value = true
    nextTick(() => {
      titleList.value = res.data.content;
    });
  });
});
const tapToChild = (e) => {
  if (e.is_children) {
    // console.log("有子菜单");

    useProIndexStore().proIndex = e.id;
    useProIndexStore().allIndex = String(e.index);
    getTitleList(useProIndexStore().proIndex, useProIndexStore().allIndex );
  } else {
    // window.open(`http://localhost:8080/prodetail?index=${e.index}`);
    window.open(`https://rekeymed.com/prodetail?index=${e.index}`);
  }

};

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "cont" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(titleList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item-nav",
            onClick: ($event: any) => (tapToChild(item)),
            key: index
          }, [
            _createElementVNode("div", _hoisted_3, [
              (item.cover)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "cover-img",
                    src: baseUrl.value + item.cover,
                    alt: ""
                  }, null, 8, _hoisted_4))
                : (_openBlock(), _createElementBlock("img", _hoisted_5))
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.label), 1)
          ], 8, _hoisted_2))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})